<nav class="main-nav">
  <a routerLink="" fragment="benefices">Bénéfices</a>
  <a routerLink="" fragment="fonctionnalites">Fonctionnalités</a>
  <a routerLink="" fragment="pricing">Pricing</a>
  <a routerLink="" fragment="societe">Société</a>
</nav>
